module.exports = __webpack_public_path__ + "static/media/Rushi.a91f5000.jpeg";